module.exports = __webpack_public_path__ + "static/media/paragon_1.7470b30d.png";